import { FormControl, FormErrorMessage, InputGroup, NumberInput, NumberInputField } from '@chakra-ui/react';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useCheckoutSFRViewModel } from '../../../models/CheckoutSFRViewModel';

type AmountFieldProps = {
  form: UseFormReturn<{ amount: number }, any>;
};

export const AmountField: React.FC<AmountFieldProps> = ({ form }) => {
  const viewModel = useCheckoutSFRViewModel();
  const suggestedAmounts = viewModel.getSuggestedAmounts();
  const sharePrice = Number(viewModel.property?.share_price ?? 0);

  return (
    <FormControl isInvalid={Boolean(form.formState.errors.amount)}>
      <Controller
        control={form.control}
        name="amount"
        rules={{
          max: {
            message: `Maximum investment amount is $${suggestedAmounts.maxAmount}`,
            value: suggestedAmounts.maxAmount,
          },
          min: {
            message: `Minimum investment amount is $${suggestedAmounts.minAmount}`,
            value: suggestedAmounts.minAmount,
          },
          required: 'Please enter an amount',
          validate: (val) => {
            if (val % sharePrice !== 0) {
              return `Only whole shares are available for purchase. Please enter an amount that is a multiple of the share price ( $${sharePrice} )`;
            }
          },
        }}
        render={({ field }) => (
          <NumberInput
            value={field.value}
            format={(value) => (value ? `$${value}` : '')}
            onChange={(val, num) => {
              const _num = isNaN(num) ? suggestedAmounts.minAmount : num;
              field.onChange(val ?? suggestedAmounts.minAmount);
              viewModel.setAmount(_num);
            }}
            inputMode="numeric"
            isValidCharacter={(character) => !isNaN(Number(character))}>
            <InputGroup>
              <NumberInputField
                id="amount"
                placeholder={`${suggestedAmounts.popularAmount}`}
                autoFocus={true}
                height="80px"
                borderStyle={'solid'}
                borderWidth="2px"
                borderColor="blue.500"
                fontSize={'24px'}
                maxLength={12}
              />
            </InputGroup>
          </NumberInput>
        )}
      />

      <FormErrorMessage>{form.formState.errors.amount?.message}</FormErrorMessage>
    </FormControl>
  );
};
